module.exports = __webpack_public_path__ + "static/media/star-fill.eb533f82.svg";